import axios, { getVariable } from "./api";
import { keycloak } from "../components/auth";

export const registerMatchAnswer = async (matchAnswer) => {
  let headers = {
    headers: {
      Authorization: "Bearer " + keycloak.token,
    },
  };

  return axios.post(
    (await getVariable("CONHECIGAME_API")) + "/v1/partida-resposta",
    matchAnswer,
    headers
  );
};
